import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import './comment-unauthorized.styl'

type Props = {
  onLinkClick: () => void
}

export default class CommentUnauthorized extends Component<Props> {
  render(): JSX.Element {
    const unauthorizedComment = (
      <span
        className="comment-unauthorized__link"
        onClick={this.props.onLinkClick}
      />
    )

    return (
      <div className="comment-unauthorized">
        <Trans id="comments.join_or_login" components={[unauthorizedComment]} />
      </div>
    )
  }
}
